// extracted by mini-css-extract-plugin
module.exports = {"Footer":"Footer_Footer__7lKRV","FooterLogos_part":"Footer_FooterLogos_part__1VpKE"};